export const plaidLinkErrorMessage = 'Something went wrong while trying to link your account'
